import { HttpGet } from "../../api/service";
import { INITIAL_STATE, LOCATION_URL, MODAL_QR } from "./types";

export const initiate = () => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('accessToken');

            if (token) {
                let user = await HttpGet('member/v1/member/me');
                
                dispatch({
                    type: INITIAL_STATE,
                    payload: {
                        isAuthenticated: true,
                        user: user,
                    }
                });

                navigator.geolocation.getCurrentPosition(function (position) {
                    let lat = position.coords.latitude;
                    let long = position.coords.longitude;

                    dispatch({
                        type: INITIAL_STATE,
                        payload: {
                            position: {
                                lat,
                                long
                            }
                        }
                    });
                });
            } else {
                dispatch({
                    type: INITIAL_STATE,
                    payload: {
                        isAuthenticated: false,
                        user: null,
                        position: null
                    }
                })
            }
        } catch (error) {
            console.log(error);
            throw (error)
        }
    }
}

export const profileSave = (token) => {
    return async (dispatch) => {
        try {
            localStorage.setItem("accessToken", token);

            let user = await HttpGet('member/v1/member/me');

            dispatch({
                type: INITIAL_STATE,
                payload: {
                    isAuthenticated: true,
                    user: user,
                }
            })

            navigator.geolocation.getCurrentPosition(function (position) {
                let lat = position.coords.latitude;
                let long = position.coords.longitude;

                dispatch({
                    type: INITIAL_STATE,
                    payload: {
                        position: {
                            lat,
                            long
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
            throw (error)
        }
    }
}

export const logout = () => {
    return async (dispatch) => {
        try {
            localStorage.removeItem('accessToken');

            dispatch({
                type: INITIAL_STATE,
                payload: {
                    isAuthenticated: false,
                    user: null,
                    location: null,
                    url: "/"
                }
            })
        } catch (error) {
            console.log(error);
            throw (error)
        }
    }
}

export const urlLocated = (location) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: LOCATION_URL,
                payload: {
                    url: location
                }
            })
        } catch (error) {
            throw (error)
        }
    }
}

export const modalQr = ({ status }) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: MODAL_QR,
                payload: {
                    qrOpen: !status
                }
            })
        } catch (error) {
            console.log(error);
            throw (error)
        }
    }
} 